<template>
  <Dashboard grafana-path="/d/KW_ranXGk/sse" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "SsePage",

  routing: {
    localizationKey: "menu.tab.sse",
    icon: "mdi-table",
    path: "/sse",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
